module.exports = __webpack_public_path__ + "cn.svg?2c193ab31269f0da8be9830738325d0f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/cn.svg
// module id = 1049
// module chunks = 0